import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Tab } from '@mui/material';
import MaterialPriceLists from './material-price-lists/material-price-lists.component';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Materials from './materials/materials.component';
import MaterialMacros from './material-macros/material-macros.component';

const MaterialSettings: FC = () => {
    const { t: translate } = useTranslation(['lab-settings']);
    const [tabState, setTabState] = useState('materials');

    const handleTabChange = (_: unknown, newTabState: string) => {
        setTabState(newTabState);
    };

    return (
        <Fragment>
            <TabContext value={tabState}>
                <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                    <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                        <Tab label={translate('lab-settings:MATERIALS')} value="materials" />
                        <Tab label={translate('lab-settings:PRICE_LISTS')} value="material-price-lists" />
                        <Tab label={translate('lab-settings:MATERIAL_MACROS')} value="material-macros" />
                    </TabList>
                </Box>
                <Box mb={3}>
                    <Divider />
                </Box>
                <TabPanel sx={{ padding: 0 }} value="materials">
                    <Materials />
                </TabPanel>

                <TabPanel sx={{ padding: 0 }} value="material-price-lists">
                    <MaterialPriceLists />
                </TabPanel>

                <TabPanel sx={{ padding: 0 }} value="material-macros">
                    <MaterialMacros />
                </TabPanel>
            </TabContext>
        </Fragment>
    );
};

export default MaterialSettings;
